// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__bk7zg","linkContainer":"Footer_linkContainer__rbikB"};